import useResponsive from './useResponsive';

export const useIsMobile = () => {
  const userAgent = typeof navigator === 'undefined' ? 'SSR' : navigator.userAgent;

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

  const isMobileResponsive = useResponsive('down', 'sm');

  return {
    isMobile: isMobile || isMobileResponsive,
  };
};
